"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StubEmailService = void 0;
const feature_1 = require("../../log/feature");
class StubEmailService {
    sendEmail(builder, options) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, feature_1.debug)('not sending email as we are using the stub email service');
            (0, feature_1.debug)('we would have sent with the data %O', options);
        });
    }
}
exports.StubEmailService = StubEmailService;
//# sourceMappingURL=StubEmailService.js.map